import React, { useEffect } from "react";
import "./DashboardDataTag.scss";
import DataEstateWidget from "./DataEstateWidget/DataEstateWidget";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_DATA_TAG_DASHBOARD_DATA } from "./DataTagConstants";
import FileClassification from "./DataTagFileClassification/FileClassification";
import DataTagSensitiveRatio from "./DataSensitiveRegulatedDataRatio/DataTagSensitiveRatio";
import DuplicateData from "./DataTagDuplicateData/DuplicateData";
import MetaDataWidget from "./MetaDataWidget/MetaDataWidget";
import DataAccessibility from "./Data Accessibility/DataAccessibility";

function Widget({ children }) {
  return <div className="widget-card">{children}</div>;
}

export default function DashboardDataTag() {
  const dispatch = useDispatch();
  const dataEstate = useSelector((state) => state.dataTagReducer.dataEstate);
  const fileClassification = useSelector(
    (state) => state.dataTagReducer.fileClassification
  );
  const sensitiveAndRegulated = useSelector(
    (state) => state.dataTagReducer.sensitiveAndRegulated
  );
  const duplicateFileData = useSelector(
    (state) => state.dataTagReducer.duplicateFileData
  );
  const metadata = useSelector((state) => state.dataTagReducer.metadata);
  const dataAccessibility = useSelector(
    (state) => state.dataTagReducer.dataAccessibility
  );

  useEffect(() => {
    dispatch({ type: FETCH_DATA_TAG_DASHBOARD_DATA });
  }, []);

  return (
    <div className="dashboard-grid">
      <Widget>
        <DataEstateWidget data={dataEstate} />
      </Widget>
      <Widget>
        <FileClassification data={fileClassification} />
      </Widget>
      <Widget>
        <DataTagSensitiveRatio data={sensitiveAndRegulated} />
      </Widget>
      <Widget>
        <DuplicateData data={duplicateFileData} />
      </Widget>
      <Widget>
        <MetaDataWidget data={metadata} />
      </Widget>
      <Widget>
        <DataAccessibility data={dataAccessibility} />
      </Widget>
    </div>
  );
}
